// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"98729375","828":"172a1fc1"}[chunkId] + ".chunk.js";
};